export const OpenLoginSignUp = (PageName, Navigation, userType, loginType) => (dispatch) => {
    dispatch({
        type: "OpenLoginSignUp",
        AuthPageName: PageName,
        Navigation: Navigation,
        userType: userType,
        loginType: loginType,
        Done: false
    })
}
export const AgainOpenLoginSignUp = (PageName) => (dispatch) => {
    dispatch({
        type: "AgainOpenLoginSignUp",
        AuthPageName: PageName,
    })
}

export const DoneLoginSignUp = (PageName) => (dispatch) => {
    dispatch({
        type: "DoneLoginSignUp",
        AuthPageName: PageName,
        Done: true
    })

}
export const ResetLoginSignUp = () => (dispatch) => {
    dispatch({
        type: "OpenLoginSignUp",
        AuthPageName: "",
        Navigation: false,
        Done: false,
        userType: "",
        loginType: ""
    })

}